import Swiper from 'swiper';
import 'viewport-checker/dist/viewportChecker.umd';
import 'selectric';


export default {
    init() {
        // JavaScript to be fired on all pages
        $('select').selectric();

        window.onscroll = myFunction;

        var header = document.getElementById('header');
        var sticky = header.offsetTop;

        function myFunction()
        {
            if (window.pageYOffset > sticky) {
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }
        }

      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $('body').addClass('touch-device');
        $('.nav > li.menu-item-has-children > a').on('click', function () {
          if ($(this).parent('.menu-item-has-children').hasClass('open')) {
            return true;
          } else {
            $(this).parent('.menu-item-has-children').addClass('open');
            return false;
          }
        });
          $('.nav li a').on('click', function () {
              var hash = $(this).attr('href');
              var parts = hash.split('#');
              if (parts.length > 1) {
                  $('.hamburger').trigger('click');
              }
          });

      } else {
        $('body').removeClass('touch-device');
      }

        $('.hamburger').on('click', function () {
            $(this).toggleClass('is-active');
            if ($(this).hasClass('is-active')) {
                $('body').addClass('menu-open');
            } else {
                $('body').removeClass('menu-open');
            }

            return false;
        });

        $('.nav > li.menu-item-has-children .drop').on('click', function () {
            $(this).closest('li').toggleClass('open');

            return false;
        });

        $('.drop-search').on('click', function () {
            $(this).closest('.search-box').toggleClass('search-active');

            return false;
        });

        if ($('#slider-default').length) {
            var generalSwiper = new Swiper('#slider-default .swiper-container', {
                navigation: {
                    nextEl: '.slider-default-button-next',
                    prevEl: '.slider-default-button-prev',
                },
                pagination: {
                    el: '.slider-default-pagination',
                    type: 'fraction',
                },
            });
            generalSwiper.init();
        }

        if ($('a img').length) {
          $('a img').parent('a').addClass('no-border');
        }

        if ($('section').length) {
          $('p iframe[src*="youtube"]').wrap("<span class='video-wrapper'></span>");
        }

        // Sticky Sidebar
        if ($('.sticky-filter-start').length) {
          $('.sticky-filter-start').StickySidebar({
            additionalMarginTop: 150,
          });
        }

        // ViewportChecker
        if (jQuery('.tribe-events-calendar-month').length) {
            jQuery('.tribe-events-calendar-month').viewportChecker({
                classToAdd: 'visible',
                repeat: false,
                offset: '25%',
            });
        }

        if (jQuery('.tribe-events-header').length) {
            jQuery('.tribe-events-header').viewportChecker({
                classToAdd: 'visible',
                repeat: false,
                offset: '25%',
            });
        }

        if (jQuery('.tribe-events-calendar-list').length) {
            jQuery('.tribe-events-calendar-list').viewportChecker({
                classToAdd: 'visible',
                repeat: false,
                offset: '25%',
            });
        }

        if (jQuery('.animation-item').length) {
            jQuery('.animation-item').viewportChecker({
                classToAdd: 'visible',
                repeat: false,
                offset: '25%',
            });
        }
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
        $('.video-player').each(function (i, player) {
            $($('.video-btn', $(player).parent()).get(0)).click(function () {
                $(this).toggleClass('pause');

                if ($(this).hasClass('pause')) {
                    player.pause();
                    $(this).removeClass('pause-video-icon');
                } else {
                    player.play();
                    $(this).addClass('pause-video-icon');
                }

                return false;
            });
        });

        parallaxImagefunction('.parallax-image-medium', 'img', 7);
        parallaxImagefunction('.parallax-image', 'img', 4);
        parallaxImagefunction('.parallax-image-light', 'img', 50);
        parallaxImagefunction('.parallax-image-bg', '.image-bg', 4);

        function parallaxImagefunction(container, object, item)
        {
            if ($(container).length) {
                $(window).scroll(function () {
                    $(container).each(function () {
                        var difference = $(window).scrollTop() - $(this).offset().top;
                        var half = (difference / item) + 'px';
                        $(this).find(object).css('top', half);
                    });
                });
            }
        }

        if ($('#news-list-container').length > 0) {
          window.loadNews(null, null, true);

          $('#news-list-container').parent().find('.load-more').on('click', function(e) {
            e.preventDefault();
            window.loadNews($('a', $('#news-categories li.active').get(0)).data('id'), true, true);
          });

          $('#news-categories a').on('click', function(e) {
            e.preventDefault();

            if ($(this).parent().hasClass('active')) {
              return false;
            }

            $('#news-categories li').removeClass('active');
            $(this).parent().addClass('active');

            $('#news-list-container').parent().find('.load-more').data('page', 1);
            window.loadNews($(this).data('id'), false);
          });
        }

        $('.scrollto').click(function (e) {
          e.preventDefault();
          const section = $(this).attr('href');
          $('html, body').animate({scrollTop: $(section).offset().top - 87}, 1000);
        });

        $('.addtoany_list a').attr('target', '_self');
    },
};

window.loadNews = function (category, append, disableScroll) {
  var container = '#news-list-container';
  var loadMoreBtn = $(container).parent().find('.load-more');
  if ($('#news-list-container article')) {
      var $scTo = $('#news-list-container');
  }

  if (append == null || append == undefined) {
    append = true;
  }

  if (category == null) {
    category = 'all';
  }

  var exclude = $(container).attr('data');
  if (!exclude || exclude == undefined) {
      exclude = 0;
  }

  let page = loadMoreBtn.data('page');
  if (isNaN(page) || page < 1) {
    page = 1;
  }

  window.showSpinner();
  $.ajax({
    url: ajax_object.ajax_url,
    method: 'get',
    data: {
      action: 'load_news_list',
      paged: page,
      category: category,
      exclude: exclude
    },
    success: function(response, textStatus, request) {
      let nextPageNum = parseInt(response.headers['X-WP-Current']);
      nextPageNum++;

      if (nextPageNum > parseInt(response.headers['X-WP-TotalPages'])) {
        loadMoreBtn.hide();
      } else {
        loadMoreBtn.show();
        loadMoreBtn.data('page', nextPageNum);
      }

      if (!append) {
        $(container).html('');
      }

      $(container).append(response.data);

      window.hideSpinner();
      if ($scTo && !disableScroll) {
          $('html, body').animate({
              scrollTop: $scTo.offset().top - 100
          }, 500);
      }

    }
  });
}

$.fn.StickySidebar = function (options) {
    var defaults = {
      'containerSelector': '',
      'additionalMarginTop': 0,
      'additionalMarginBottom': 0,
      'updateSidebarHeight': true,
      'minWidth': 0,
      'disableOnResponsiveLayouts': true,
      'sidebarBehavior': 'modern'
    };
    options = $.extend(defaults, options);

    // Validate options
    options.additionalMarginTop = parseInt(options.additionalMarginTop) || 0;
    options.additionalMarginBottom = parseInt(options.additionalMarginBottom) || 0;

    tryInitOrHookIntoEvents(options, this);

    // Try doing init, otherwise hook into window.resize and document.scroll and try again then.
    function tryInitOrHookIntoEvents(options, $that) {
      var success = tryInit(options, $that);

      if (!success) {
        console.log('TST: Body width smaller than options.minWidth. Init is delayed.');

        $(document).scroll(function (options, $that) {
          return function (evt) {
            var success = tryInit(options, $that);

            if (success) {
              $(this).unbind(evt);
            }
          };
        }(options, $that));
        $(window).resize(function (options, $that) {
          return function (evt) {
            var success = tryInit(options, $that);

            if (success) {
              $(this).unbind(evt);
            }
          };
        }(options, $that))
      }
    }

    // Try doing init if proper conditions are met.
    function tryInit(options, $that) {
      if (options.initialized === true) {
        return true;
      }

      if ($('body').width() < options.minWidth) {
        return false;
      }

      init(options, $that);

      return true;
    }

    // Init the sticky sidebar(s).
    function init(options, $that) {
      options.initialized = true;

      // Add CSS
      $('head').append($('<style>.StickySidebar:after {content: ""; display: table; clear: both;}</style>'));

      $that.each(function () {
        var o = {};

        o.sidebar = $(this);

        // Save options
        o.options = options || {};

        // Get container
        o.container = $(o.options.containerSelector);
        if (o.container.length == 0) {
          o.container = o.sidebar.parent();
        }

        // Create sticky sidebar
        o.sidebar.parents().css('-webkit-transform', 'none'); // Fix for WebKit bug - https://code.google.com/p/chromium/issues/detail?id=20574
        o.sidebar.css({
          'position': 'relative',
          'overflow': 'visible',
          // The "box-sizing" must be set to "content-box" because we set a fixed height to this element when the sticky sidebar has a fixed position.
          '-webkit-box-sizing': 'border-box',
          '-moz-box-sizing': 'border-box',
          'box-sizing': 'border-box'
        });

        // Get the sticky sidebar element. If none has been found, then create one.
        o.stickySidebar = o.sidebar.find('.StickySidebar');
        if (o.stickySidebar.length == 0) {
          o.sidebar.find('script').remove(); // Remove <script> tags, otherwise they will be run again on the next line.
          o.stickySidebar = $('<div>').addClass('StickySidebar').append(o.sidebar.children());
          o.sidebar.append(o.stickySidebar);
        }

        // Get existing top and bottom margins and paddings
        o.marginTop = parseInt(o.sidebar.css('margin-top'));
        o.marginBottom = parseInt(o.sidebar.css('margin-bottom'));
        o.paddingTop = parseInt(o.sidebar.css('padding-top'));
        o.paddingBottom = parseInt(o.sidebar.css('padding-bottom'));

        // Add a temporary padding rule to check for collapsable margins.
        var collapsedTopHeight = o.stickySidebar.offset().top;
        var collapsedBottomHeight = o.stickySidebar.outerHeight();
        o.stickySidebar.css('padding-top', 1);
        o.stickySidebar.css('padding-bottom', 1);
        collapsedTopHeight -= o.stickySidebar.offset().top;
        collapsedBottomHeight = o.stickySidebar.outerHeight() - collapsedBottomHeight - collapsedTopHeight;
        if (collapsedTopHeight == 0) {
          o.stickySidebar.css('padding-top', 0);
          o.stickySidebarPaddingTop = 0;
        }
        else {
          o.stickySidebarPaddingTop = 1;
        }

        if (collapsedBottomHeight == 0) {
          o.stickySidebar.css('padding-bottom', 0);
          o.stickySidebarPaddingBottom = 0;
        }
        else {
          o.stickySidebarPaddingBottom = 1;
        }

        // We use this to know whether the user is scrolling up or down.
        o.previousScrollTop = null;

        // Scroll top (value) when the sidebar has fixed position.
        o.fixedScrollTop = 0;

        // Set sidebar to default values.
        resetSidebar();

        o.onScroll = function (o) {
          // Stop if the sidebar isn't visible.
          if (!o.stickySidebar.is(":visible")) {
            return;
          }

          // Stop if the window is too small.
          if ($('body').width() < o.options.minWidth) {
            resetSidebar();
            return;
          }

          // Stop if the sidebar width is larger than the container width (e.g. the theme is responsive and the sidebar is now below the content)
          if (o.options.disableOnResponsiveLayouts) {
            var sidebarWidth = o.sidebar.outerWidth(o.sidebar.css('float') == 'none');

            if (sidebarWidth + 50 > o.container.width()) {
              resetSidebar();
              return;
            }
          }

          var scrollTop = $(document).scrollTop();
          var position = 'static';

          // If the user has scrolled down enough for the sidebar to be clipped at the top, then we can consider changing its position.
          if (scrollTop >= o.container.offset().top + (o.paddingTop + o.marginTop - o.options.additionalMarginTop)) {
            // The top and bottom offsets, used in various calculations.
            var offsetTop = o.paddingTop + o.marginTop + options.additionalMarginTop;
            var offsetBottom = o.paddingBottom + o.marginBottom + options.additionalMarginBottom;

            // All top and bottom positions are relative to the window, not to the parent elemnts.
            var containerTop = o.container.offset().top;
            var containerBottom = o.container.offset().top + getClearedHeight(o.container);

            // The top and bottom offsets relative to the window screen top (zero) and bottom (window height).
            var windowOffsetTop = 0 + options.additionalMarginTop;
            var windowOffsetBottom;

            var sidebarSmallerThanWindow = (o.stickySidebar.outerHeight() + offsetTop + offsetBottom) < $(window).height();
            if (sidebarSmallerThanWindow) {
              windowOffsetBottom = windowOffsetTop + o.stickySidebar.outerHeight();
            }
            else {
              windowOffsetBottom = $(window).height() - o.marginBottom - o.paddingBottom - options.additionalMarginBottom;
            }

            var staticLimitTop = containerTop - scrollTop + o.paddingTop + o.marginTop;
            var staticLimitBottom = containerBottom - scrollTop - o.paddingBottom - o.marginBottom;

            var top = o.stickySidebar.offset().top - scrollTop;
            var scrollTopDiff = o.previousScrollTop - scrollTop;

            // If the sidebar position is fixed, then it won't move up or down by itself. So, we manually adjust the top coordinate.
            if (o.stickySidebar.css('position') == 'fixed') {
              if (o.options.sidebarBehavior == 'modern') {
                top += scrollTopDiff;
              }
            }

            if (o.options.sidebarBehavior == 'stick-to-top') {
              top = options.additionalMarginTop;
            }

            if (o.options.sidebarBehavior == 'stick-to-bottom') {
              top = windowOffsetBottom - o.stickySidebar.outerHeight();
            }

            if (scrollTopDiff > 0) { // If the user is scrolling up.
              top = Math.min(top, windowOffsetTop);
            }
            else { // If the user is scrolling down.
              top = Math.max(top, windowOffsetBottom - o.stickySidebar.outerHeight());
            }

            top = Math.max(top, staticLimitTop);

            top = Math.min(top, staticLimitBottom - o.stickySidebar.outerHeight());

            // If the sidebar is the same height as the container, we won't use fixed positioning.
            var sidebarSameHeightAsContainer = o.container.height() == o.stickySidebar.outerHeight();

            if (!sidebarSameHeightAsContainer && top == windowOffsetTop) {
              position = 'fixed';
            }
            else if (!sidebarSameHeightAsContainer && top == windowOffsetBottom - o.stickySidebar.outerHeight()) {
              position = 'fixed';
            }
            else if (scrollTop + top - o.sidebar.offset().top - o.paddingTop <= options.additionalMarginTop) {
              // Stuck to the top of the page. No special behavior.
              position = 'static';
            }
            else {
              // Stuck to the bottom of the page.
              position = 'absolute';
            }
          }

          /*
           * Performance notice: It's OK to set these CSS values at each resize/scroll, even if they don't change.
           * It's way slower to first check if the values have changed.
           */
          if (position == 'fixed') {
            o.stickySidebar.css({
              'position': 'fixed',
              'width': o.sidebar.width(),
              'top': top,
              'left': o.sidebar.offset().left + parseInt(o.sidebar.css('padding-left'))
            });
          }
          else if (position == 'absolute') {
            var css = {};

            if (o.stickySidebar.css('position') != 'absolute') {
              css.position = 'absolute';
              css.top = scrollTop + top - o.sidebar.offset().top - o.stickySidebarPaddingTop - o.stickySidebarPaddingBottom;
            }

            css.width = o.sidebar.width();
            css.left = '';

            o.stickySidebar.css(css);
          }
          else if (position == 'static') {
            resetSidebar();
          }

          if (position != 'static') {
            if (o.options.updateSidebarHeight == true) {
              o.sidebar.css({
                'min-height': o.stickySidebar.outerHeight() + o.stickySidebar.offset().top - o.sidebar.offset().top + o.paddingBottom
              });
            }
          }

          o.previousScrollTop = scrollTop;
        };

        // Initialize the sidebar's position.
        o.onScroll(o);

        // Recalculate the sidebar's position on every scroll and resize.
        $(document).scroll(function (o) {
          return function () {
            o.onScroll(o);
          };
        }(o));
        $(window).resize(function (o) {
          return function () {
            o.stickySidebar.css({'position': 'static'});
            o.onScroll(o);
          };
        }(o));

        // Reset the sidebar to its default state
        function resetSidebar() {
          o.fixedScrollTop = 0;
          o.sidebar.css({
            'min-height': '1px'
          });
          o.stickySidebar.css({
            'position': 'static',
            'width': ''
          });
        }

        // Get the height of a div as if its floated children were cleared. Note that this function fails if the floats are more than one level deep.
        function getClearedHeight(e) {
          var height = e.height();

          e.children().each(function () {
            height = Math.max(height, $(this).height());
          });

          return height;
        }
      });
    }
  }



// WEBPACK FOOTER //
// ./scripts/routes/common.js